export default "__VITE_ASSET__BqqrwOpv__"